import { Heart } from 'lucide-react';
import { useWishlist } from '@/context/WishlistContext';

export function WishlistButton({ productId, className = '', compact = false }) {
  const { isSaved, toggle } = useWishlist();
  const saved = isSaved(productId);
  return <button
    type="button"
    data-testid={`wishlist-toggle-${productId}`}
    onClick={() => toggle(productId)}
    aria-label={saved ? 'Remove from saved pieces' : 'Save this piece'}
    aria-pressed={saved}
    className={`flex items-center justify-center border border-[#D1D1D6] bg-white text-[#1E1E1E] transition-[background-color,transform,color] duration-200 hover:-translate-y-0.5 hover:border-[#8A9A86] hover:bg-[#C7D1C3] ${compact ? 'h-10 w-10' : 'h-12 w-12'} ${className}`}
  >
    <Heart size={compact ? 16 : 18} fill={saved ? 'currentColor' : 'none'} />
  </button>;
}